import { CompactComments, SimpleIconList, VideoConferenceTimer } from "@components"
import { AcademicCapIcon, BookOpenIcon, CheckCircleIcon, PresentationChartBarIcon, UserIcon, XCircleIcon } from "@heroicons/react/24/outline"
import { Scrollbars } from 'react-custom-scrollbars-2';
import PropTypes from "prop-types"

const BookingDetailsPane = ({ 
  bookingDetails, 
  handleUpdateTeacherComment, 
  vcAutoDisconnect 
}) => {

  return (
    <div className="relative text-white bg-jitsi-black h-[250px] sm:h-[300px] xl:h-full xl:w-[330px] 2xl:w-[396px] flex-shrink-0">
      <Scrollbars 
        autoHide
        renderThumbVertical={({ style, ...props }) => (
          <div {...props} style={{ ...style, backgroundColor: "#797878", borderRadius: "5px" }} />
        )}
      >
        <div className="px-8 py-6">
          <VideoConferenceTimer classNames="md:absolute xl:static right-7 mb-4" startTime={bookingDetails.starts_at} endTime={bookingDetails.ends_at} autoDisconnect={vcAutoDisconnect} />
          
          <div className="mb-8">
            <h2 className="text-lg font-semibold text-content2-foreground">General</h2>
            
            <SimpleIconList 
              items={[
                { icon: <UserIcon />, caption: bookingDetails.parent, description: "Parent" },
                { icon: <AcademicCapIcon />, caption: bookingDetails.student, description: "Student" },
                { icon: <PresentationChartBarIcon />, caption: bookingDetails.lesson, description: "Lesson" },
                { icon: <BookOpenIcon />, caption: bookingDetails.subject, description: "Subject" },
                { icon: vcAutoDisconnect ? <CheckCircleIcon /> : <XCircleIcon />, caption: "Auto Disconnect", description: "Auto Disconnect" },
              ]}
            />
          </div>

          <CompactComments
            id={bookingDetails.booking_slot_id}
            classNames={{ label: "!text-lg font-semibold" }}
            initialTeacherComment={bookingDetails.teacher_comments} 
            parentComment={bookingDetails.parent_comments} 
            handleUpdateTeacherComment={(comment) => handleUpdateTeacherComment(comment)}
            showEditButton
          />
        </div>
      </Scrollbars>
    </div>
  )
}

BookingDetailsPane.propTypes = {
  bookingDetails: PropTypes.shape({
    parent: PropTypes.string,
    student: PropTypes.string,
    lesson: PropTypes.string,
    subject: PropTypes.string,
    starts_at: PropTypes.object,
    ends_at: PropTypes.object,
  }).isRequired,
  handleUpdateTeacherComment: PropTypes.func.isRequired,
  vcAutoDisconnect: PropTypes.bool.isRequired
}

export default BookingDetailsPane